import { Component, Element, Fragment, Host, h, Prop, Event, EventEmitter } from '@stencil/core';

export type UuiPanelExpansionDirection = 'column' | 'row';

@Component({
  tag: 'uui-expansion-panel-header',
  styleUrl: 'uui-expansion-panel-header.css',
  shadow: true
})

/**
 * @slot default - Slot for the content of the uui-card.
 */
export class UuiExpansionPanelHeader {
  /** width of a card */
  @Prop() width: string = 'auto';
  /** header text */
  @Prop() header: string;
  /** description text */
  @Prop() description: string = '';
  /** direction of title and description */
  @Prop() direction: UuiPanelExpansionDirection = 'column';
  @Event({
    eventName: 'panelExpand',
    composed: true,
    cancelable: true,
    bubbles: true
  })
  panelExpand: EventEmitter<string>;
  @Prop({ mutable: true, reflect: false }) expanded: boolean = false;
  @Prop({ mutable: false, reflect: false }) panelId: string = '';
  @Element() el: HTMLElement;

  hasTitleSlot: boolean;
  hasDescriptionSlot: boolean;

  componentWillLoad(): void {
    this.hasTitleSlot = !!this.el.querySelector(
      '[slot="title"]'
    );

    this.hasDescriptionSlot = !!this.el.querySelector(
      '[slot="description"]'
    );
  }

  onPanelExpand() {
    this.panelExpand.emit(this.panelId);
  }

  render() {
    return (
      <Host>
        <button
          onClick={this.onPanelExpand.bind(this)}
          id={this.panelId}
          aria-expanded={`${this.expanded}`}
        >
          <slot name="image"></slot>
          <span class="uui-expansion-title-container">
            {this.hasTitleSlot ? (
              <slot name="title"></slot>
            ) : (
              <Fragment>
                <span class="uui-expansion-title">{this.header}</span>
                {this.hasDescriptionSlot ? <slot name="description"></slot> : <span class="uui-expansion-description">{this.description}</span>}
              </Fragment>
            )}  
          </span>
          <span class="uui-expansion-icon"></span>
        </button>
      </Host>
    );
  }
}
